/**
 * Created by why on 2019/12/23.
 */
import {
  editTransaction,
  delTransactionByIds,
  getTransactionByCode,
  getTransactionByCondition
} from '@/api/transaction-record-manage'

export default {
  state: {
    list: [],
    infoList: [],
    infoLoading: false,
    loading: false,
    loadingSave: false,
    pageSize: 10,
    pageNum: 1,
    total: 0
  },
  mutations: {
    setTransactionList (state, list) {
      state.list = list
    },
    setTransactionLoading (state, loading) {
      state.loading = loading
    },
    setTransactionPageSize (state, pageSize) {
      state.pageSize = pageSize
    },
    setTransactionPageNum (state, pageNum) {
      state.pageNum = pageNum
    },
    setTransactionTotal (state, total) {
      state.total = total
    },
    setTransactionLoadingSave (state, loadingSave) {
      state.loadingSave = loadingSave
    },
    setInfoList (state, list) {
      state.infoList = list
    },
    setInfoLoading (state, loading) {
      state.infoLoading = loading
    }
  },
  getters: {
    infoData: state => state.infoList,
    infoLoading: state => state.infoLoading,
    transactionList: state => state.list,
    transactionTotal: state => state.total,
    transactionLoading: state => state.loading,
    transactionLoadingSave: state => state.loadingSave
  },
  actions: {
    getTransactionByCondition ({ state, commit }, data) {
      commit('setTransactionLoading', true)
      return new Promise((resolve, reject) => {
        getTransactionByCondition(data).then(res => {
          const data = res.data.result
          const list = data.records
          const pageSize = data.pageSize
          const pageNum = data.pageNum
          const total = data.total
          commit('setTransactionList', list)
          commit('setTransactionLoading', false)
          commit('setTransactionPageSize', pageSize)
          commit('setTransactionPageNum', pageNum)
          commit('setTransactionTotal', total)
          resolve(res)
        }).catch(err => {
          commit('setTransactionLoading', false)
          reject(err)
        })
      })
    },
    delTransactionByIds ({ state, commit }, ids) {
      return new Promise((resolve, reject) => {
        delTransactionByIds(ids).then(res => {
          resolve(res)
        }).catch(err => {
          reject(err)
        })
      })
    },
    editTransaction ({ state, commit }, data) {
      commit('setTransactionLoadingSave', true)
      return new Promise((resolve, reject) => {
        editTransaction(data).then(res => {
          commit('setTransactionLoadingSave', false)
          resolve(res)
        }).catch(err => {
          commit('setTransactionLoadingSave', false)
          reject(err)
        })
      })
    },
    getTransactionByCode ({ state, commit }, data) {
      commit('setInfoLoading', true)
      return new Promise((resolve, reject) => {
        getTransactionByCode(data).then(res => {
          const data = res.data.result
          commit('setInfoLoading', false)
          commit('setInfoList', data)
          resolve(res)
        }).catch(err => {
          commit('setInfoLoading', false)
          reject(err)
        })
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/module/transaction-record-manage.js